import React, { useRef, useState, useEffect, useContext } from "react";
import { TimeLine } from "../../../../components/timeLine/TimeLine";
import { ISubtitles } from "../../../../types/videoResponse";
import { Subtitles } from "../../../../components/subtitles/Subtitles";
import { ISelectedRange, ISubtitleWord } from "../../../../components/subtitles/SubtitlesTypes";
import { SubtitlesWidgetSaving } from "./SubtitlesWidgetSaving";
import { formatDate2, timeFromSeconds } from "../../../../utils/dateFormats";
import { formatTimeOnly } from "../../../../utils/timezone";
import { AppContext } from "../../../../appContext";
import "./SubtitlesWidget.css";

interface ISubtitlesWidgetProps{
    selectedTime:number, 
    subtitles: ISubtitles,
    onSelectTime: (time: number)=>void, 
    isCollapsed: boolean, 
    onCollapse: (value: boolean)=>void, 
    onWordSave: (segmentIndex: number, wordIndex: number, text: string)=>void, 
    onSave: (selections: any)=>Promise<any>,
    onSelectionAction: (action: string, selection:ISelectedRange)=>void;
    date: string;
    startDatetime?: string;
    folderSelectionToAdd?: ISelectedRange | null;
}

export const SubtitlesWidget = ({subtitles, onSelectTime, selectedTime, isCollapsed, onCollapse, onWordSave, onSave, onSelectionAction, date, startDatetime, folderSelectionToAdd}: ISubtitlesWidgetProps) => {
    const { translate, currentLanguage } = useContext(AppContext);
    const subtitlesRef = useRef<HTMLDivElement>(null);
    const [selections, setSelections] = useState<ISelectedRange[]>([]);

    useEffect(()=>{
        if (folderSelectionToAdd) {
            setSelections(last => [...last, folderSelectionToAdd]);
        }
    }, [folderSelectionToAdd]);
    const [linePoints, setLinePoints] = useState<{value: number, label: string}[]>([]);
    //const [isSubtitlesCollapsed, setSubtitlesCollapsed] = useState(true);
    const [resizeFix, setResizeFix] = useState(window.innerWidth);
    const [hoverWord, setHoverWord] = useState<{word:ISubtitleWord, element: HTMLElement}>(null);

    useEffect(()=>{
        const handler = ()=>{
            setResizeFix(window.innerWidth);
        };
        window.addEventListener('resize', handler);
        return ()=> window.removeEventListener('resize', handler);
    }, []);

    useEffect(()=>{
        if (subtitlesRef.current && subtitles){
            const times = subtitles.segments.map((it)=>it.start);
            const positions = [...subtitlesRef.current.children].map((child: HTMLDivElement)=>child.offsetTop);
            const points = positions.map((it, i)=>({value: it, label: timeFromSeconds(times[i])}));
            setLinePoints(points);
        }
    }, [subtitlesRef.current, subtitles, resizeFix]);

    return (
        <div className={`subtitlesWidget ${isCollapsed ? 'subtitlesWidget--collapsed' : ''}`}>
            <div className="button subtitlesWidget_close" onClick={()=>{onCollapse(!isCollapsed)}}>
                {translate('minimize')}
            </div>
            <div className="subtitlesWidget_header">
                <div className="subtitlesWidget_header_date">
                    {(() => {
                        const sessionDate = new Date(date);
                        const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                        const dayKey = `day_${dayNames[sessionDate.getDay()]}`;
                        const translatedDay = translate(dayKey);
                        const dateStr = `${translatedDay}, ${formatDate2(sessionDate).split(', ')[1] || formatDate2(sessionDate)}`;
                        
                        // Add time from startDatetime if available
                        if (startDatetime) {
                            const timeStr = formatTimeOnly(startDatetime, undefined, currentLanguage);
                            return `${dateStr} ${timeStr}`;
                        }
                        
                        return dateStr;
                    })()}
                </div>
                <div className="subtitlesWidget_header_transcription">
                    {translate('transcription_of_session')}
                </div> 
            </div>
            <div className="scroll subtitlesWidget_scroll">
                <div className="subtitlesWidget_content">
                    <TimeLine 
                        noRound={true}
                        points={linePoints} 
                        selectedPoints={hoverWord ? [{
                            value: hoverWord.element.offsetTop,
                            label: timeFromSeconds(hoverWord.word.start)
                        }] : []}
                    ></TimeLine>
                    <Subtitles 
                        ref={subtitlesRef} 
                        onWordSave={onWordSave}
                        onHoverWord={(word)=>{
                            setHoverWord(word);
                        }}
                        onSave={onSave} 
                        subtitles={subtitles} 
                        selectedTime={selectedTime} 
                        onWordClick={(time)=>{
                            onSelectTime(time);
                        }}
                        onSelectionAction={onSelectionAction}
                        selections={selections}
                        setSelections={setSelections}
                        ></Subtitles>
                </div>
            </div>
            {/*<div className="button" onClick={()=>onSave(selections)}>
                save
            </div>*/}
            <SubtitlesWidgetSaving selections={selections} subtitles={subtitles} save={()=>{
                //return new Promise(resolve=> setTimeout(()=>{resolve(true)}, 1000));
                return onSave(selections);
            }}></SubtitlesWidgetSaving>
        </div>
    )
}